<script>
  import Vue from 'vue'
  import { castArray } from 'vtils'
  import { pxToRem } from '@/utils'

  export default Vue.extend({
    props: {
      colCount: {
        type: Number,
        required: true,
      },
      gap: {
        type: Number,
        default: 0,
      },
      rowGap: {
        type: Number,
        default: 0,
      },
      colGap: {
        type: Number,
        default: 0,
      },
      square: {
        type: [Boolean, Number],
        default: false,
      },
    },

    computed: {
      gridStyle() {
        const cols = `repeat(${this.colCount}, 1fr)`
        const gap = `${pxToRem(this.rowGap || this.gap)}rem ${pxToRem(
          this.colGap || this.gap,
        )}rem`
        return {
          'gridTemplateColumns': cols,
          'gridGap': gap,
          'gap': gap,
          '--square': this.square === true ? '100%' : `${this.square * 100}%`,
        }
      },
    },

    render(h) {
      return h(
        'div',
        {
          class: [this._.grid, this.square && this._.square],
          style: this.gridStyle,
        },
        !this.square
          ? this.$slots.default
          : castArray(this.$slots.default || []).map(node =>
              h(
                'div',
                {
                  class: this._.square,
                },
                [node],
              ),
            ),
      )
    },
  })
</script>

<style lang="scss" module>
  .grid {
    display: grid;

    .square {
      position: relative;

      > *:first-child {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        width: 100%;
        height: 100%;
      }

      &::after {
        content: '';
        display: block;
        padding-bottom: var(--square);
      }
    }
  }
</style>
